export const GUEST_DAILY_LIMIT = 3
export const FREE_DAILY_LIMIT = 10
export const STORAGE_KEY = 'am-chat-access-mock-v1'

export const chatLimitsMock = {
    plan: 'pro',
    tokensUsed: 418,
    tokensTotal: 500,
}

export function estimateTokens(text) {
    if (!text) {
        return 0
    }
    return Math.max(1, Math.ceil(text.length / 4))
}

function readState() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) {
            return null
        }
        return JSON.parse(raw)
    } catch (error) {
        return null
    }
}

function writeState(next) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    } catch (error) {
        // ignore
    }
}

function today() {
    const d = new Date()
    return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
}

export function loadAccessState() {
    const state = readState() || {}
    const day = today()

    return {
        guestUsed: typeof state.guestUsed === 'number' ? state.guestUsed : 0,
        freeUsed: state.freeDay === day && typeof state.freeUsed === 'number' ? state.freeUsed : 0,
        freeDay: day,
    }
}

export function persistAccessState(state) {
    writeState({
        guestUsed: state.guestUsed,
        freeUsed: state.freeUsed,
        freeDay: state.freeDay,
    })
}
